module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_05A.a1e1defc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_05A.mp3
// module id = 116
// module chunks = 0